import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { GridView, ViewList, PhotoLibrary } from '@mui/icons-material';
import { ViewMode } from './viewModeUtils';

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

/**
 * Three-button toggle for switching between Grid, List, and Image Only views.
 */
export const ViewModeToggle = ({ value, onChange }: ViewModeToggleProps) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newMode: ViewMode | null) => {
    // ToggleButtonGroup passes null when clicking the already-selected button
    if (newMode !== null) {
      onChange(newMode);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size="small"
    >
      <ToggleButton value="grid" aria-label="Grid view">
        <GridView fontSize="small" />
      </ToggleButton>
      <ToggleButton value="list" aria-label="List view">
        <ViewList fontSize="small" />
      </ToggleButton>
      <ToggleButton value="image" aria-label="Image only view">
        <PhotoLibrary fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
